<script setup lang="ts">
import { onMounted, onBeforeMount } from "vue"
import { useRouter, useRoute } from "vue-router"
import { useLogin } from "@/stores/login";

import MainWeb from '@/components/mainWeb.vue';

const router = useRouter();
const route = useRoute();
const login = useLogin();

onBeforeMount(async () => {
  if (route.path === "/") {
    // 檢查 URL 中是否有 m_user_c_cookie 參數
    const urlMUC = login.getUrlMUserC();
    
    if (urlMUC) {
      // 如果有,處理登入邏輯
      await login.handleUrlMUserC();
      
      // 清除 URL 中的參數並導向到 main 頁面
      const baseUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, '', baseUrl + '#/main');
      router.replace({name: 'main'})
    } else {
      // 沒有參數則正常導向
      router.push({name: 'main'})
    }
  }
})
</script>

<template>
    <MainWeb />
</template>
